export default {
  "center": "_center_i44b2_1"
};import "ni:sha-256;zAcnsbylt255acEfzLxiX4mFFSPbNuk9uzJskB3DLx4";